export const IAM_DID = ({ IDL }) => {
    const UserId = IDL.Principal;
    const Profile = IDL.Record({
        id: UserId,
        username: IDL.Text,
        role: IDL.Text,
        email: IDL.Text,
    });
    const NewProfilePayload = IDL.Record({
        username: IDL.Text,
        email: IDL.Text,
    });
    const UpdateProfilePayload = IDL.Record({
        username: IDL.Opt(IDL.Text),
        email: IDL.Opt(IDL.Text),
    });
    return IDL.Service({
        checkUsername: IDL.Func([IDL.Text], [IDL.Bool], ['query']),
        deleteProfile: IDL.Func([], [], []),
        deleteUserProfile: IDL.Func([IDL.Principal], [], []),
        getAdmin: IDL.Func([], [IDL.Principal], ['query']),
        getProfile: IDL.Func([], [IDL.Opt(Profile)], ['query']),
        getUsers: IDL.Func([], [IDL.Vec(Profile)], ['query']),
        lookup: IDL.Func([IDL.Text], [IDL.Opt(IDL.Principal)], ['query']),
        lookupUsername: IDL.Func([IDL.Principal], [IDL.Opt(IDL.Text)], ['query']),
        register: IDL.Func([NewProfilePayload], [], []),
        setAdmin: IDL.Func([IDL.Principal], [], []),
        updateProfile: IDL.Func([UpdateProfilePayload], [IDL.Opt(Profile)], []),
        updateRole: IDL.Func([IDL.Principal, IDL.Text], [IDL.Opt(IDL.Null)], []),
        updateUserProfile: IDL.Func([IDL.Principal, UpdateProfilePayload], [IDL.Opt(Profile)], []),
    });
};
//# sourceMappingURL=did.js.map